import { createSlice } from "@reduxjs/toolkit";
import {
  deleteTermsFromCheckOut,
  updateTermsToCampaigns,
} from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";
const initialState = {
  isLoading: false,
  status: null,
  error: null,
  user: null,
};
export const termsApplyCampaignSlice = createSlice({
  name: "termscampaign",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateTermsToCampaigns.pending, (state) => {
        state.isLoading = true;
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateTermsToCampaigns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.updateSubmiterms = action.payload;
      })
      .addCase(updateTermsToCampaigns.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "failed";
        state.error = action.error?.message || "Something went wrong";
        message.error("Something went wrong!");
      });

    // deleting the terms
    builder
      .addCase(deleteTermsFromCheckOut.pending, (state) => {
        state.error = null;
        state.isLoading = true;
        state.deleteStatus = null;
      })
      .addCase(deleteTermsFromCheckOut.fulfilled, (state, action) => {
        state.isLoading = false;
        state.deleteStatus = action.payload;
      })
      .addCase(deleteTermsFromCheckOut.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
        state.deleteStatus = null;
        message.error("Something went wrong!");
      });
  },
});
export default termsApplyCampaignSlice.reducer;
